export enum CoreGlobalProperties {
  I18nConfig = "I18nConfig",
}
